import * as React from 'react'
import { connect } from 'react-redux'
import {Container, Card, CardImg, Row, CardHeader} from "reactstrap";
import {ApplicationState} from "src/store";
import {
    SpecialOfferCompactList, SpecialOfferCompactListInner,
    UsedMainCategories,
    UsedMainCategoriesInner
} from "src/services/api";
import {selectCategoryPageAction, selectSpecialOfferPageAction} from "App/routes";
import {selectedLang} from "App/helper";
import {WithTranslation, withTranslation} from "react-i18next";
import {Language, linkToProduct, NATURAL_SORT_COMPARE_OPTIONS} from "App/constants";
import {CarouselBox} from "App/components/CarouselBox";

interface StateToProps {
    categories: UsedMainCategories;
    specialoffers: SpecialOfferCompactList
}

interface DispatchToProps {
    onChoose: (catId: number) => void
    onChooseSpecialOffer: (item: SpecialOfferCompactListInner) => void
}

const mapStateToProps = (state: ApplicationState): StateToProps => ({
    categories: state.data.categories || [],
    specialoffers: state.data.specialoffers || []
});

const mapDispatchToProps = (dispatch: any) : DispatchToProps => ({
    onChoose: (catId:number) => dispatch(selectCategoryPageAction(catId)),
    onChooseSpecialOffer: (item: SpecialOfferCompactListInner) => {
        if (item.products.length>1) {
            // Go on the special offers page
            dispatch(selectSpecialOfferPageAction(item.id))
        } else if (item.products.length) {
            // Directly open the product
            window.open(linkToProduct(item.products[0].id),"_self")
        }
    }
});

class _Container extends React.PureComponent<StateToProps & DispatchToProps & WithTranslation> {
    render() {
        const {i18n, t, categories, specialoffers, onChoose, onChooseSpecialOffer} = this.props;
        const language: Language = selectedLang(i18n);
        return  <Container className="py-5">
            <Row>
            {
                categories
                    .sort((i1:UsedMainCategoriesInner, i2:UsedMainCategoriesInner) => (i1.nameml[language]||'').localeCompare(i2.nameml[language]||'', undefined, NATURAL_SORT_COMPARE_OPTIONS))
                    .map((category:UsedMainCategoriesInner, index: number) => (
                    <div className="col-md-3 col-sm-3 col-xs-3" key={category.id}>
                    <Card className="productListWrap" onClick={() => onChoose(category.id)}>
                        <CardHeader className={"text-truncate"}>{category.nameml[language]}</CardHeader>
                        <CardImg src={category.iconurl} alt={category.nameml[language]} className="p-2"/>
                    </Card>
                    </div>)
                )
            }
            </Row>
            {
                specialoffers&&specialoffers.length?
                    <React.Fragment>
                    <Row className="mt-4 mx-0 mb-0 px-5 py-3 d-flex align-items-center conf-title">
                        <span className="m-0 float-left title-normal-uppercase">{t('products.configuration.specialofferstitle')}</span>
                    </Row>
                    <Row>
                        <CarouselBox className={"px-3 pt-5"} onChooseAction={onChooseSpecialOffer} items={specialoffers.sort(
                            (s1, s2) => (
                            s1.nameml[language]||'').localeCompare(s2.nameml[language]||'', undefined, NATURAL_SORT_COMPARE_OPTIONS) ||
                                (s1.descriptionml[language]||'').localeCompare(s2.descriptionml[language]||'', undefined, NATURAL_SORT_COMPARE_OPTIONS)
                        )}/>
                    </Row>
                    </React.Fragment>:
                    null
            }
            </Container>
    }
}

export const MainPage = connect (mapStateToProps, mapDispatchToProps)(withTranslation('common')(_Container));


// WEBPACK FOOTER //
// ./src/containers/MainPage.tsx